var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classnames,attrs:{"id":"app","el":"app"}},[_c('div',{staticClass:"content",class:{ isHover: _vm.isCursorPointer }},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }